// extracted by mini-css-extract-plugin
module.exports = {"whitePanel":"Header_whitePanel__jL_3g","colorPanel":"Header_colorPanel__Tbi_n","container":"Header_container__lNHAk","brand":"Header_brand__DPv9P","nav":"Header_nav__gb_7D"};